module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-prologue element-with-heading",
    attrs: {
      "id": "prologue"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('div', {
    staticClass: "heading-ornament-block heading-ornament-aspect-wide"
  }, [_c('div', {
    staticClass: "heading-ornament-size-container"
  }, [_c('img', {
    staticClass: "heading-ornament-image",
    attrs: {
      "alt": "",
      "src": "images/heading-swash-ornate-screen.png"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "prologue-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-center"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("THE NARRATIVE OF ARTHUR GORDON PYM")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-center"
  }, [_vm._v("OF NANTUCKET")])])]), _vm._v(" "), _c('p', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width first-with-first-letter-c"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("C")]), _vm._v("OMPRISING THE DETAILS OF A MUTINY AND ATROCIOUS BUTCHERY ON BOARD THE AMERICAN BRIG "), _c('i', [_vm._v("GRAMPUS")]), _vm._v(", ON HER WAY TO THE SOUTH SEAS, IN THE MONTH OF JUNE 1827.")]), _vm._v(" "), _c('p', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("WITH AN ACCOUNT")]), _vm._v(" OF THE RECAPTURE OF THE VESSEL BY THE SURVIVERS; THEIR SHIPWRECK AND SUBSEQUENT HORRIBLE SUFFERINGS FROM FAMINE; THEIR DELIVERANCE BY MEANS OF THE BRITISH SCHOONER "), _c('i', [_vm._v("JANE GUY")]), _vm._v("; THE BRIEF CRUISE OF THIS LATTER VESSEL IN THE ANTARCTIC OCEAN; HER CAPTURE, AND THE MASSACRE OF HER CREW AMONG A GROUP OF ISLANDS IN THE EIGHTY-FOURTH PARALLEL OF SOUTHERN LATITUDE; TOGETHER WITH THE INCREDIBLE ADVENTURES AND DISCOVERIES STILL FARTHER SOUTH TO WHICH THAT DISTRESSING CALAMITY GAVE RISE.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33c1691e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/prologue.vue
// module id = 75
// module chunks = 0